import { render, staticRenderFns } from "./ghiab.vue?vue&type=template&id=3dd2fa53&"
import script from "./ghiab.vue?vue&type=script&lang=js&"
export * from "./ghiab.vue?vue&type=script&lang=js&"
import style0 from "./ghiab.vue?vue&type=style&index=0&id=3dd2fa53&prod&lang=css&"
import style1 from "./ghiab.vue?vue&type=style&index=1&id=3dd2fa53&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports